<template>
    <div>
        <div class="lock-word animated fadeInDown">
            <span class="first-word">&nbsp;&nbsp;ZMIEŃ&nbsp; </span><span>&nbsp;HASŁO</span>
        </div>
        <div class="middle-box text-center lockscreen animated fadeInDown">
            <div>
                <div class="m-b-md">
                    <img alt="image" class="rounded-circle circle-border" src="https://s3.amazonaws.com/uifaces/faces/twitter/ok/128.jpg">
                </div>
                <h3>{{ name }}</h3>
                <p>Zmień hasło do systemu</p>
                <p>Po zmianie zostaniesz wylogowany, zaloguj się używając nowego hasła.</p>
                <form
                    class="m-t"
                    :class=" { 'sk-loading': loading } "
                    role="form"
                    @submit.prevent="handleSubmit"
                    v-if="!sended"
                >
                    <div class="sk-spinner sk-spinner-wave">
                        <div class="sk-rect1"></div>
                        <div class="sk-rect2"></div>
                        <div class="sk-rect3"></div>
                        <div class="sk-rect4"></div>
                        <div class="sk-rect5"></div>
                    </div>
                    <div
                        class="form-group"
                        :class="{'has-error': errors.has('password')}"
                    >
                        <input
                            type="password"
                            class="form-control"
                            placeholder="Nowe hasło"
                            required=""
                            v-model="credentials.password"
                            v-validate="'required'"
                            name="password"
                        >
                        <small
                            v-show="errors.has('password')"
                            class="text-danger"
                        >
                            {{ $t( 'field_required' ) }}
                        </small>
                    </div>
                    <div
                        class="form-group"
                        :class="{'has-error': errors.has('re_password')}"
                    >
                        <input
                            type="password"
                            class="form-control"
                            placeholder="Powtórz hasło"
                            v-model="credentials.re_password"
                            v-validate="'required'"
                            name="re_password"
                        >
                        <small
                            v-show="errors.has('re_password')"
                            class="text-danger"
                        >
                            {{ $t( 'field_required' ) }}
                        </small>
                    </div>
                    <button
                        type="submit"
                        class="btn btn-primary block full-width m-b"
                    >
                        Zmień hasło
                    </button>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
    name: 'SetNewPassword',
    computed: {
        ...mapGetters( 'users', [
            'roles',
            'active',
            'name',
            'id'
        ] ),
        ...mapActions( 'auth', [
            'logout'
        ] )
    },
    beforeCreate() {
        document.querySelector( 'body' ).classList.add( 'gray-bg' )
    },
    data() {
        return {
            loading: false,
            credentials: {
                password: '',
                re_password: ''
            },
            sended: false
        }
    },
    methods: {
        handleSubmit() {
            this.$validator.validateAll().then( result => {
                if ( result ) {
                    this.loading = true
                    this.$http.put( `users/password/${ this.id }`, this.credentials )
                        .then( () => {
                            this.$toastr.success( 'Hasło zostało zmienione' )
                            this.loading = false
                            this.sended = true
                            this.logout()
                        } )
                        .catch( () => {
                            this.loading = false
                            // this.$toastr.error( 'Podałeś błędne dane' )
                        } )
                }
            } )
        }
    }
}
</script>

